import EventDispatcher from '../util/EventDispatcher';
import { isLocalStorageAvailable } from '../util/localStorage';

var userIdLocalStoryKey = 'userId';
var profileLocalStoryKey = 'profile';
var userId;
var profile;

if (isLocalStorageAvailable) {
  userId = localStorage.getItem(userIdLocalStoryKey)
    ? parseInt(localStorage.getItem(userIdLocalStoryKey))
    : null;
  profile = localStorage.getItem(profileLocalStoryKey)
    ? JSON.parse(localStorage.getItem(profileLocalStoryKey))
    : {};
}

var isUpdated = false;
var eventDispatcher = new EventDispatcher();

// On every page load retrieve the latest server side state
// of the user, we do this to make sure the local state is
// the same as the server state.
if (isLocalStorageAvailable) {
  fetchUserData();
}

async function fetchUserData() {
  try {
    const json = await fetch('/api/accounts/profile/');
    const data = await json.json();
    if (data && data.userId && !userId) {
      // Server is logged in, but we are not
      // let's save new user id and render favorites
      setUserData(data.userId, data);
    } else if (data && data.userId && data.userId !== userId) {
      // Server has a different user then we are,
      // let's save new user and render favorites
      setUserData(data.userId, data);
    } else if (data && !data.userId && userId) {
      // Server is not logged in, but client-side thinks
      // it is logged in, remove user id and clear favorites
      unsetUserData();
    } else {
      // Everything is fine! Just make sure everything is
      // up to date
      setUserData(data.userId, data);
    }
    isUpdated = true;
  } catch (err) {
    console.error('Error fetching user data', err);
    unsetUserData();
  }
}

function setUserData(_userId, _profile) {
  userId = _userId;
  profile = _profile;
  localStorage.setItem(userIdLocalStoryKey, userId);
  localStorage.setItem(profileLocalStoryKey, JSON.stringify(profile));
  eventDispatcher.dispatchEvent(new CustomEvent('update', { detail: profile }));
}

function unsetUserData() {
  userId = undefined;
  profile = {};
  localStorage.removeItem(userIdLocalStoryKey);
  localStorage.removeItem(profileLocalStoryKey);
  eventDispatcher.dispatchEvent(new CustomEvent('update', { detail: profile }));
}

function getUserId() {
  return userId;
}

function getProfile() {
  return profile;
}

function isAuthenticated() {
  return !!userId;
}

export default {
  setUserData: setUserData,
  unsetUserData: unsetUserData,
  getUserId,
  getProfile,
  isAuthenticated,
  addEventListener: (type, listener) =>
    eventDispatcher.addEventListener(type, listener),
  isUpdated: () => isUpdated,
};
